import { Button } from '@mui/material';
import { fontWeight } from '../theme/typography';
import { palette } from '../theme/palette';
import { styled } from '@mui/material/styles';

const BaseButton = styled(Button)(() => ({
  fontSize: '14px',
  letterSpacing: '.5px',
  height: '40px',
  color: 'white',
  borderRadius: '1px',
  boxShadow: 'none',
  ':hover': {
    boxShadow: 'none',
  },
}));

export const PrimaryButton = styled(BaseButton)`
  background: ${palette.primary.main};
  border-radius: 5px;
  height: 34px;
  padding: 0 20px;
  font-size: 13.5px;
  letter-spacing: 0.675px;
  text-transform: uppercase;
  :hover {
    background: ${palette.primary.main};
    color: 'white';
  }
  &.Mui-disabled {
    color: ${palette.custom.white};
    opacity: .5;
  }
`;

export const PrimaryLightButton = styled(BaseButton)`
  border-radius: 5px;
  border: 1px solid ${palette.primary.main};
  color: ${palette.custom.darkGrey};
  height: 34px;
  font-size: 13.5px;
  letter-spacing: 0.675px;
  text-transform: uppercase;
  :hover {
    background: ${palette.primary.contrastText};
  }
`;

export const SecondaryButton = styled(BaseButton)`
  background: ${palette.custom.darkGrey};
  border-radius: 5px;
  height: 34px;
  padding: 0 20px;
  font-size: 13.5px;
  letter-spacing: 0.675px;
  text-transform: uppercase;
  color: ${palette.custom.white};
  :hover {
    background: ${palette.custom.darkGrey};
    color: ${palette.custom.white};
  }
`;

export const LinkButton = styled(Button)`
  padding: 0;
  background: none;
  :hover {
    background: none;
  }
`;

export const OutlineButton = styled(BaseButton)`
  background: ${palette.custom.white};
  border: 1px solid ${palette.custom.darkGrey};
  border-radius: 5px;
  color: ${palette.custom.darkGrey};
  font-size: 12px;
  font-weight: ${fontWeight.bold};
  height: 40px;
  line-height: normal;
  letter-spacing: 0.6px;
  padding: 5px 10px;
  text-align: center;
  text-transform: uppercase;
  width: fit-content;
  :hover {
    color: ${palette.custom.white};
    background: ${palette.custom.darkGrey};
  }
`;
